import { ImageUrl } from '@dvui';

export const styleForCustomLogo = (imageURL: String) => {
    return {
        backgroundImage: 'url(' + imageURL + ')',
    }
}

export const isMoving = (imageURL: String) => imageURL.split('.').pop() === 'gif';

export const reduceMotion = (imageURL: string) => encodeURI(
    new ImageUrl(imageURL).forceFormat('png').getImageUrl()
)